<template>
  <div class="ag-add-desicion p-4" v-if="addDescion && addDescion !== 'null'">
    <ul class="ag-add-desicion-list">
      <li>
        <span class="bold-text">{{ $t("Role") }}</span>
        <span class="value">{{ addDescion.rolePolicy }}</span>
      </li>
      <li>
        <span class="bold-text">{{ $t("Mode") }} </span>
        <span class="value">{{ addDescion.modeName }}</span>
      </li>
      <li>
        <span class="bold-text">{{ $t("Action") }}</span>
        <span class="value">{{ addDescion.action }}</span>
      </li>
      <li>
        <span class="bold-text">{{ $t("Actor") }}</span>
        <span class="value">{{ addDescion.actor }}</span>
      </li>
      <li>
        <span class="bold-text">{{ $t("Target") }}</span>
        <span class="value">{{ addDescion.target }}</span>
      </li>
      <li>
        <span class="bold-text">{{ $t("computersAffected") }}</span>
        <span class="value"
          >{{ addDescion.effectedComputerCount }} of
          {{ addDescion.totalComputerCount }} ({{
            addDescion.percentageComputer
          }}%)</span
        >
      </li>
      <li>
        <span class="bold-text">{{ $t("events") }}</span>
        <span class="value">{{ addDescion.eventCount }}</span>
      </li>
      <li>
        <span class="bold-text">{{ $t("decision") }}</span>
        <span class="value form-item">
          <li class="form-group" v-for="(item, i) in decisions" :key="i">
            <label :for="item.name">
              <input
                type="radio"
                :id="item.name"
                :value="item.id"
                name="decisionId"
                :disabled="!selectedRow.notEditable"
                v-model="addDescion.decisionId"
              />
              {{ item.decisionName }}
            </label>
          </li>
        </span>
      </li>

      <li v-if="addDescion.decisionId !== 2">
        <span class="bold-text">{{ $t("option") }}</span>
        <span class="value form-item">
          <li class="form-group">
            <select
              name=""
              id=""
              class="form-control"
              v-model="addDescion.decisionOptionId"
              :disabled="!selectedRow.notEditable"
            >
              <option
                v-for="(item, key) in options"
                :key="key"
                :value="item.key"
              >
                {{ item.name }}
              </option>
            </select>
          </li>
        </span>
      </li>

      <li v-if="addDescion.decisionId !== 2">
        <span class="bold-text">{{ $t("saveAs") }}</span>
        <span class="value form-item">
          <li class="form-group" v-for="(item, i) in decisionStatuses" :key="i">
            <label :for="item.decisionStatusName">
              <input
                type="radio"
                :id="item.decisionStatusName"
                :value="item.id"
                name="decisionStatus"
                v-model="addDescion.decisionStatusId"
                :disabled="item.id === 3 || !selectedRow.notEditable"
              />
              <span v-if="item.id !== 3"> {{ item.decisionStatusName }}</span>
              <span style="color: #c9c8c8" v-else>
                {{ item.decisionStatusName }}</span
              >
            </label>
          </li>
        </span>
      </li>

      <!-- <li>
        <span class="bold-text">Scope : </span>
        <span class="value form-item">
          <li class="form-group">
            <label for="group">
              <input
                type="radio"
                id="group"
                value="Group"
                name="scope"
                v-model="addDescion.scope"
              />
              Group
            </label>
          </li>
          <li class="form-group">
            <label for="company">
              <input
                type="radio"
                id="company"
                value="Company"
                name="scope"
                v-model="addDescion.scope"
              />
              Company
            </label>
          </li>
        </span>
      </li> -->
      <!-- <li style="margin-top: -22px">
        <span class="bold-text"> </span>
        <span class="value">
          <p>
            <small
              >In which level do you want to resolve this block ? <br />
              Company selection moves your draft into the Company-wide drafted
              list.</small
            >
          </p>
        </span>
      </li> -->
    </ul>
  </div>
</template>

<script>
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import BlockRequiringReview from "../../helpers/pages/BlockRequiringReview";
import PolicyReviewChecklist from "../../helpers/pages/PolicyReviewChecklist";
import { ref } from "vue";
import api from "@/api/index";
import { useI18n } from "vue-i18n";

const store = useStore();
export default {
  name: "ag-add-desicion",
  data: () => ({
    addDescion: {
      id: "",
      eventId: "",
      rolePolicy: "",
      uniqueEventHash: "",
      mode: "",
      action: "",
      actor: "",
      target: "",
      effectedComputerCount: "",
      totalComputerCount: "",
      eventCount: "",
      percentageComputer: "",
      policyFileVersion: "",
      lastStatusChange: "",
      groupGuid: "",
      decisionId: "",
      decision: "",
      decisionStatusId: "",
      option: "",
      decisionStatus: "",
      scope: "",
    },
    scopes: [],
    modes: [],
    decisionStatuses: [],
    decisionOptions: [],
    decisions: [],
    options: [
      {
        key: 5,
        name: "Allow Launch (Default)",
      },
      {
        key: 4,
        name: "Add Power App",
      },
      {
        key: 3,
        name: "Add Power App For Parent",
      },
      {
        key: 2,
        name: "Add Trusted Folder",
      },
      {
        key: 1,
        name: "Add Trusted Folder For Parent",
      },
      {
        key: 6,
        name: "Configure Ignore Message",
      },
    ],
  }),
  setup() {
    const module = ref(BlockRequiringReview);
    const modulePolicy = ref(PolicyReviewChecklist);
    const { t, locale } = useI18n();
    return {
      t,
      module,
      modulePolicy,
    };
  },
  async mounted() {
    this.getList();
    const scopes = await api.policyReview.getScopes();
    this.scopes = scopes.data.entityData;
    const modes = await api.policyReview.getModes();
    this.modes = modes.data.entityData;
    const decisionStatuses = await api.policyReview.getDecisionStatus();
    this.decisionStatuses = decisionStatuses.data.entityData;
    const decisionOptions = await api.policyReview.decisionOptions();
    this.decisionOptions = decisionOptions.data.entityData;
    const decisions = await api.policyReview.getDecisions();
    this.decisions = decisions.data.entityData;
    this.setDefaults();
    this.setOptionsData();
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
  watch: {
    selectedRow() {
      this.getList();
      this.setOptionsData();
      this.setDefaults();
    },
    addDescion: {
      deep: true,
      handler() {
        this.module.models.addDescion = this.addDescion;
        this.modulePolicy.models.addDescion = this.addDescion;
        store.dispatch(GeneralActionTypes.SET_SELECTED_ROW, this.addDescion);
      },
    },
  },
  methods: {
    setOptionsData() {
      if (this.addDescion.action === "Blocked Process") {
        this.options = [
          {
            key: 5,
            name: "Allow Launch (Default)",
          },
          {
            key: 4,
            name: "Add Power App",
          },
          {
            key: 3,
            name: "Add Power App For Parent",
          },
          {
            key: 2,
            name: "Add Trusted Folder",
          },
          {
            key: 1,
            name: "Add Trusted Folder For Parent",
          },
          {
            key: 6,
            name: "Configure Ignore Message",
          },
        ];
      }
      if (
        this.addDescion.action === "Blocked File Read" ||
        this.addDescion.action === "Blocked File Write"
      ) {
        this.options = [
          {
            key: 7,
            name: "Allow to Write / Read (Default)",
          },
          {
            key: 8,
            name: "Add Parent to Power App",
          },
          {
            key: 1,
            name: "Add Trusted Folder for Parent",
          },
          {
            key: 6,
            name: "Configure Ignore Message",
          },
        ];
      }
      if (
        this.addDescion.action === "Blocked Registry Read" ||
        this.addDescion.action === "Blocked Registry Write"
      ) {
        this.options = [
          {
            key: 7,
            name: "Allow to Write / Read (Default)",
          },
          {
            key: 8,
            name: "Add Parent to Power App",
          },
          {
            key: 1,
            name: "Add Trusted Folder for Parent",
          },
          {
            key: 6,
            name: "Configure Ignore Message",
          },
        ];
      }
      if (
        this.addDescion.action === "Blocked Memory Read" ||
        this.addDescion.action === "Blocked Memory Write"
      ) {
        this.options = [
          {
            key: 7,
            name: "Allow to Write / Read (Default)",
          },
          {
            key: 8,
            name: "Add Parent to Power App",
          },
          {
            key: 1,
            name: "Add Trusted Folder for Parent",
          },
          {
            key: 6,
            name: "Configure Ignore Message",
          },
        ];
      }
      if (this.addDescion.action === "Blocked Code Load") {
        this.options = [
          {
            key: 7,
            name: "Allow to Load (Default)",
          },
          {
            key: 8,
            name: "Add Parent to Power App",
          },
          {
            key: 1,
            name: "Add Trusted Folder for Parent",
          },
          {
            key: 6,
            name: "Configure Ignore Message",
          },
        ];
      }
    },
    setSelectedDecisionOption() {
      if (this.addDescion.action === "Blocked Process") {
        return 5;
      }else if (
        this.addDescion.action === "Blocked File Read" ||
        this.addDescion.action === "Blocked File Write"
      ) {
        return 7;
      }else if (
        this.addDescion.action === "Blocked Registry Read" ||
        this.addDescion.action === "Blocked Registry Write"
      ) {
        return 7;
      }else if (
        this.addDescion.action === "Blocked Memory Read" ||
        this.addDescion.action === "Blocked Memory Write"
      ) {
        return 7;
      }
    },
    getList() {
      if (store.state.general.selectedExpandedRow) {
        this.addDescion = store.state.general.selectedExpandedRow;
      }
    },
    setDefaults() {
      try {
        if (this.$route.fullPath == "/administration/policy-review/drafted") {
          this.addDescion.decisionStatusId = 1;
        } else if (
          this.$route.fullPath == "/administration/policy-review/applied"
        ) {
          this.addDescion.decisionStatusId = 2;
        } else if (
          this.$route.fullPath == "/administration/policy-review/published"
        ) {
          this.addDescion.decisionStatusId = 3;
        } else {
          this.addDescion.decisionStatusId = 1;
        }

        this.addDescion.decisionId = this.addDescion.decisionId
          ? this.addDescion.decisionId
          : this.decisions.length > 0
          ? this.decisions[0].id
          : null;

        this.addDescion.scope = this.addDescion.scope
          ? this.addDescion.scope
          : "Group";
        this.addDescion.decisionOptionId = this.addDescion.decisionOptionId
          ? this.addDescion.decisionOptionId
          : this.setSelectedDecisionOption();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss">
#exportJSON {
  margin-left: 0 !important;
  margin-bottom: 1.5rem;
}

.ag-data {
  height: 60vh;
  overflow: auto;
}

.ag-add-desicion-list {
  list-style: none;
  padding: 0;
  margin: 15px 0;
  flex-wrap: wrap;
  width: 70%;
  margin: 0 auto;
}

.ag-add-desicion-list label {
  font-size: 16px !important;
}

.ag-add-desicion-list.wrap {
  padding-top: 70px;
  justify-content: center;
  align-items: center;
}

.ag-add-desicion-list li {
  flex-direction: row;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 6px 15px;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-start;
}

.ag-add-desicion-list li .form-group {
  padding: 10px 0px;
}

.ag-add-desicion-list li .bold-text {
  color: #5e5e5e;
  font-weight: bold;
  font-size: 16px;
  text-align: right;
  width: 30%;
}

.ag-add-desicion-list li .value {
  color: #8e8e8e;
  font-size: 30px;
  color: #8e8e8e;
  font-size: 16px;
  margin-left: 10px;
  text-align: left;
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.ag-add-desicion-list li .value.form-item {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: auto;
}

.ag-add-desicion-list li .value.form-item .form-group {
  margin-right: 20px;
}
.ag-add-desicion-list li .value.form-item .form-group label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.ag-add-desicion-list li .value.form-item .form-group input[type="radio"] {
  margin-right: 8px;
}

input[type="radio"] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: #fff;
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: currentColor;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid currentColor;
  border-radius: 50%;
  transform: translateY(-0.075em);

  display: grid;
  place-content: center;
}

input[type="radio"]::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  border-radius: 50%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em #4c8dbb;
  background-color: #4c8dbb;
}

input[type="radio"]:checked::before {
  transform: scale(1);
}

input[type="radio"]:focus {
  outline: max(2px, 0.15em) solid #4c8dbb;
  outline-offset: max(2px, 0.15em);
}

.ag-add-desicion-list li .raw {
  color: #8e8e8e;
  font-size: 12px;
}

.ag-add-desicion-list.dropList {
  flex-direction: column;
  margin-top: 70px;
}

.ag-add-desicion-list.dropList li {
  width: 100%;
}

.ag-modal .modal-body {
  background: #f8f8f8;
}

.ag-modal .modal-body textarea {
  border-color: #ddd;
  padding: 15px;
}

.ag-modal .modal-body label {
  color: #8e8e8e;
  font-size: 14px;
  margin: 0;
}
</style>